import {Language, Platform} from "@variocube/app-api";
import {AbstractApp} from "@variocube/app-common";
import * as React from "react";
import {Component} from "react";
import icon from "./logo.png";
import {render} from "react-dom";

export default class RadioOe1 extends AbstractApp {

    constructor(platform:Platform) {
        super(platform, icon, 'transparent', [Language.DE]);
        this.name = "Radio Ö1";
        this.description = "gehört gehört";
        this.updateLauncherItems();
    }

    render(root: Element) {
        render(<HomeScreen/>, root);
    }

}

class HomeScreen extends Component {
    render() {
        return (
            <div>
                <iframe src="https://oe1.orf.at/player/live" style={{ width:"100%", height:"100%"}} />
            </div>
        )
    }
}

